var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertDanger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 294,
    viewBox: "0 0 318 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4543 284.343C-3.40357 266.981-17.6447 214.276 29.6434 166.612 76.9315 118.949 167.837 94.386 232.695 111.748 297.553 129.109 311.794 181.815 264.506 229.478 217.218 277.142 126.312 301.705 61.4543 284.343z",
    fill: "#a2eaf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.069 235.392C214.063 213.189 238.377 178.582 227.375 158.095 216.373 137.608 174.222 138.999 133.227 161.202 92.2326 183.405 67.9189 218.012 78.9209 238.499 89.9228 258.986 132.074 257.595 173.069 235.392z",
    fill: "#6edfee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.501 172.059C220.698 162.248 233.538 155.847 247.976 152.078 262.23 148.351 264.785 139.543 255.34 136.684 244.63 133.442 231.266 139.4 222.645 147.682 207.625 162.115 205.744 173.162 205.744 173.162L212.501 172.059z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M212.501 172.059C220.698 162.248 233.538 155.847 247.976 152.078 262.23 148.351 264.785 139.543 255.34 136.684 244.63 133.442 231.266 139.4 222.645 147.682 207.625 162.115 205.744 173.162 205.744 173.162L212.501 172.059z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.272 171.483C208.214 171.483 208.147 171.466 208.089 171.441 207.881 171.34 207.798 171.09 207.898 170.881 220.064 145.81 246.984 139.643 253.533 140.111 253.766 140.127 253.932 140.328 253.915 140.562 253.899 140.796 253.682 140.963 253.466 140.946 247.075 140.453 220.621 146.571 208.638 171.249 208.58 171.399 208.43 171.483 208.272 171.483z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.732 174.667C205.732 176.438 207.646 177.516 209.169 176.622 216.792 172.168 227.909 169.703 245.908 174.842 255.478 177.575 260.188 175.745 262.202 171.834 264.44 167.488 259.697 163.285 254.288 161.304 235.873 154.543 219.255 159.156 205.732 172.644V174.667z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.781 175.026C206.664 175.026 206.556 174.976 206.473 174.884 206.323 174.708 206.331 174.449 206.506 174.29 222.408 160.017 247.04 162.8 256.36 168.365 256.56 168.482 256.626 168.741 256.501 168.942 256.385 169.143 256.127 169.201 255.927 169.084 246.79 163.627 222.65 160.919 207.055 174.917 206.98 174.984 206.88 175.026 206.781 175.026z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.827 215.649C86.1033 207.137 69.1993 204.105 51.3497 204.617 33.7147 205.126 27.8172 195.867 37.7118 189.418 48.9254 182.103 66.2849 184.452 78.9685 191.067 101.087 202.595 106.963 214.647 106.963 214.647L98.827 215.649z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M98.827 215.649C86.1033 207.137 69.1993 204.105 51.3497 204.617 33.7147 205.126 27.8172 195.867 37.7118 189.418 48.9254 182.103 66.2849 184.452 78.9685 191.067 101.087 202.595 106.963 214.647 106.963 214.647L98.827 215.649z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.486 213.575C103.554 213.557 103.624 213.516 103.68 213.47 103.883 213.286 103.897 212.965 103.713 212.761 81.2938 188.064 48.2858 190.019 40.9318 192.753 40.6714 192.853 40.5431 193.136 40.6438 193.397 40.7445 193.659 41.0454 193.78 41.2875 193.688 48.4661 190.974 80.9102 189.119 102.981 213.431 103.111 213.583 103.314 213.627 103.486 213.575z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.796 214.054C107.67 217.041 105.095 219.89 102.049 219.297 92.0535 217.385 79.0409 218.933 61.3876 230.06 51.3204 236.408 45.2965 235.89 41.6587 232.081 37.6219 227.845 41.6613 221.426 47.2021 217.334 66.0742 203.404 86.7277 203.12 106.796 214.054z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.389 217.142C106.525 217.105 106.638 217.014 106.699 216.879 106.821 216.631 106.714 216.329 106.458 216.21 83.3862 205.164 56.0244 216.627 47.1903 226.145 47.0044 226.344 47.0122 226.667 47.2202 226.85 47.419 227.037 47.7409 227.03 47.9228 226.822 56.5803 217.499 83.4017 206.267 106.029 217.11 106.151 217.167 106.275 217.179 106.389 217.142z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.796 22.7519 221.671 22.6767C221.663 22.6767 221.663 22.6683 221.654 22.6683L189.933 4.3332C189.925 4.32484 189.916 4.32484 189.9 4.31648L189.716 4.22455V4.23291C174.896-3.27162 155.124-1.0236 133.863 12.7904 91.1404 40.5354 58.5785 104.399 61.1415 155.427 62.423 180.865 72.1841 198.306 86.9464 205.969V205.978L87.0795 206.044C87.0878 206.044 87.0878 206.053 87.0962 206.053L118.826 224.396C118.834 224.396 118.834 224.405 118.843 224.405L119.001 224.488V224.48C133.821 232.009 153.61 229.761 174.896 215.947 217.618 188.202 250.18 124.339 247.617 73.3113 246.319 47.8645 236.558 30.4235 221.796 22.7519z",
    fill: "#c60808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.735 223.812 87.0954 206.045C87.0704 206.045 87.0704 206.045 87.0704 206.045L86.9289 205.961C72.175 198.273 62.4139 180.832 61.1407 155.427 60.0007 132.671 65.8506 107.374 76.4439 83.8748L76.6602 83.3566 108.182 102.21C97.5638 125.701 91.7304 150.998 92.8704 173.762 94.1187 198.666 103.497 215.889 117.735 223.812z",
    fill: "#b80000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.88 215.939C217.602 188.194 250.164 124.33 247.593 73.3027 245.03 22.2753 208.316 3.39699 165.593 31.142 122.871 58.887 90.309 122.751 92.872 173.778 95.4433 224.806 132.158 243.684 174.88 215.939z",
    fill: "#ff3c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.21 182.448 161.236 137.47 151.682 131.933 125.655 176.911C120.731 185.41 120.767 194.571 125.711 197.404L135.265 202.941C130.322 200.126 130.285 190.947 135.21 182.448z",
    fill: "#c01e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.438 45.8593C210.966 44.4612 207.72 44.9027 204.492 46.7607 201.264 48.6186 198.018 51.9115 195.546 56.1609L169.52 101.12 179.074 106.657 205.101 61.6981C207.572 57.4486 210.8 54.1742 214.047 52.2978 217.274 50.4398 220.521 49.9799 222.993 51.3964L213.438 45.8593z",
    fill: "#c01e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.046 122.57 125.491 117.033C120.529 114.218 120.511 105.057 125.436 96.5213 127.889 92.2719 131.135 88.9974 134.363 87.1395 137.61 85.2815 140.838 84.8216 143.328 86.2381L152.882 91.7752C150.411 90.3587 147.164 90.8186 143.936 92.6766 140.69 94.5346 137.462 97.8274 135.009 102.058 130.066 110.594 130.102 119.755 135.046 122.57z",
    fill: "#c01e1e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.711 118.707 191.156 113.17 217.349 128.07 226.903 133.607 200.711 118.707z",
    fill: "#931116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.571 93.6148 146.998 88.0776 173.209 102.96 182.764 108.497 156.571 93.6148z",
    fill: "#931116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.737 54.1374C220.965 52.2794 224.211 51.8195 226.683 53.236 231.644 56.069 231.681 65.2301 226.738 73.7289L200.712 118.707 226.922 133.626C231.884 136.422 231.921 145.601 226.978 154.119 224.524 158.368 221.278 161.642 218.05 163.5 214.822 165.358 211.576 165.818 209.086 164.402L182.893 149.501 156.849 194.497C154.395 198.747 151.149 202.021 147.921 203.898 144.693 205.756 141.447 206.216 138.975 204.799 134.032 201.966 133.995 192.787 138.92 184.306L164.946 139.328 138.754 124.446C133.81 121.632 133.773 112.47 138.698 103.935 141.152 99.6854 144.398 96.411 147.626 94.553 150.872 92.695 154.1 92.2351 156.572 93.6516L182.783 108.534 208.809 63.5744C211.262 59.2882 214.49 56.0138 217.737 54.1374z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.9 184.288 164.926 139.31 155.371 133.773 129.345 178.751C124.42 187.249 124.457 196.411 129.4 199.243L138.955 204.781C134.012 201.966 133.975 192.787 138.9 184.288z",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.127 47.6988C214.656 46.3008 211.409 46.7423 208.181 48.6002 204.953 50.4582 201.707 53.7511 199.235 58.0005L173.209 102.96 182.764 108.497 208.79 63.5376C211.262 59.2882 214.49 56.0137 217.736 54.1374 220.964 52.2794 224.21 51.8195 226.682 53.236L217.127 47.6988z",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.735 124.409 129.181 118.872C124.219 116.058 124.2 106.897 129.125 98.3609 131.578 94.1115 134.825 90.837 138.053 88.979 141.299 87.1211 144.527 86.6612 147.017 88.0776L156.572 93.6148C154.1 92.1983 150.854 92.6582 147.626 94.5162 144.379 96.3742 141.152 99.667 138.698 103.898 133.755 112.434 133.792 121.595 138.735 124.409z",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M208.5 54C213 55.0448 211.33 58.8065 211 59.5l-28.5 49-9-5.5 28-48.5C203.5 52.5 203.466 52.4858 204 52l4.5 2z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 272.193,
    y1: 154.324,
    x2: 192.057,
    y2: 154.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 274.405,
    y1: 167.507,
    x2: 191.587,
    y2: 167.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 108.427,
    y1: 186.219,
    x2: 26.5983,
    y2: 221.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 115.797,
    y1: 200.118,
    x2: 25.7966,
    y2: 238.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h318v294H0z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertDanger);
export default __webpack_public_path__ + "static/media/ico-alert-danger.cdea82562adc445e8e610ccc49443c83.svg";
export { ForwardRef as ReactComponent };